import { makeStyles } from '@material-ui/core/styles'

export const MyWellnessStyles = makeStyles((theme) => ({
  wellnessListContainer: {
    padding: 0,
    margin: 0,
    height: 428,
    maxHeight: 428,
    width: 335,
    overflowY: 'hidden',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 246px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  wellnessCardGrid: {
    overflowX: 'hidden',
    overflowY: 'auto',
    height: '100%',
  },
  wellnessObject: {
    width: '100%',
    height: 'auto',
    marginBottom: 9,
    marginLeft: 5,
    marginRight: 5,
    textAlign: 'left',
    color: 'white',
    [theme.breakpoints.down(400)]: {
      width: 280,
    },
  },
  image: {
    width: '100%',
    borderRadius: '5px',
  },
  divider: {
    width: '100%',
  },
  header: {
    margin: theme.spacing(0.5, 0),
  },
  detailListContainer: {
    height: 379,
    maxHeight: 379,
    width: 335,
    margin: 0,
    overflowX: 'hidden',
    overflowY: 'auto',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 298px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  footer: {
    height: '50px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    marginBottom: 0,
    boxShadow: 3,
    width: '100%',
  },
  description: {
    padding: '10px',
  },
  videoCard: {
    textAlign: 'left',
  },
  videoButton: {
    backgroundColor: theme.palette.backgroundColor.secondary,
  },
  myWellnessLinks: {
    textDecoration: 'underline',
    fontSize: '1rem',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  },
}))

export default MyWellnessStyles
